export const getFileSize = (size: number) => {
	const converted = size / 1000000;

	if (converted < 0.1) {
		return converted.toFixed(3);
	}

	return converted.toFixed(1);
};
